/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    p: "p",
    pre: "pre",
    code: "code",
    h2: "h2"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.h1, {
    id: "radio"
  }, "Radio"), "\n", React.createElement(_components.p, null, "Form radio input component"), "\n", React.createElement(_components.pre, null, React.createElement(_components.code, {
    className: "language-js"
  }, "import { Radio } from 'theme-ui'\n")), "\n", React.createElement(_components.pre, null, React.createElement(_components.code, {
    className: "language-js",
    live: "true"
  }, "<Label>\n  <Radio\n    name='dark-mode'\n    value='true'\n    defaultChecked={true}\n  />\n  Dark Mode\n</Label>\n<Label>\n  <Radio\n    name='dark-mode'\n    value='false'\n  />\n  Light Mode\n</Label>\n")), "\n", React.createElement(_components.h2, {
    id: "variants"
  }, "Variants"), "\n", React.createElement(_components.p, null, "Radio variants can be defined in ", React.createElement(_components.code, null, "theme.forms"), " and the component uses the ", React.createElement(_components.code, null, "theme.forms.radio"), " variant by default."));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
